import React from "react";
import user2 from "./pRonny.png";
import user3 from "./pHainer.png";

export default function MyTeam() {
  return (
    <section class="team section-padding" id="team">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="sectioner-header text-center">
              <h3>Nuestro Equipo</h3>
              <span class="line"></span>
              <p>
                Nuestro equipo de trabajo combina habilidades y conocimientos
                clave para impulsar el crecimiento y la eficiencia de cada
                negocio o empresa.
              </p>
            </div>
            <div class="section-content text-center">
              <div class="row">
                <div class="col-md-4">
                  <div class="team-detail wow bounce" data-wow-delay="0.4s">
                    <img src={user3} class="img-fluid" />
                    <h4>Hainer Gonzalez</h4>
                    <p>CEO & Fundador</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="team-detail wow bounce" data-wow-delay="0.6s">
                    <a
                      href="https://ronnytoledo.github.io/Portafolio/index.html"
                      rel="noopener noreferrer"
                    >
                      <img src={user2} class="img-fluid" />
                    </a>
                    <h4>Ronny Toledo</h4>
                    <p>Desarrollador Web & Fundador</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
